module.exports = __webpack_public_path__ + "884aaf96bc348e8920fd56a7612cac01.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/pages/HomePage2/Technology/bottom-right.jpg
// module id = 872
// module chunks = 1